/** Shared loaders let navigation and speculative prefetch use the same chunks. */
export const routeLoaders = {
  AdminFeedback: () => import('./pages/AdminFeedback'),
  InspectionMode: () => import('./pages/InspectionMode'),
  Reports: () => import('./pages/Reports'),
  Settings: () => import('./pages/Settings'),
  AdminConsultancies: () => import('./pages/AdminConsultancies'),
  AdminLabReportsTest: () => import('./pages/AdminLabReportsTest'),
  AssetTypeRegistry: () => import('./pages/AssetTypeRegistry'),
  LabReports: () => import('./pages/LabReports'),
  LabReportDetail: () => import('./pages/LabReportDetail'),
  ClientPortalLabReports: () => import('./pages/ClientPortal/ClientPortalLabReports'),
  ClientPortalWrmp: () => import('./pages/ClientPortal/ClientPortalWrmp'),
};

/** Warm routes after paint without surfacing speculative network failures. */
export function scheduleRoutePrefetch(loaders: Array<() => Promise<unknown>> = Object.values(routeLoaders)): () => void {
  const prefetch = () => { loaders.forEach(load => { void load().catch(() => {}); }); };
  if (window.requestIdleCallback) {
    const handle = window.requestIdleCallback(prefetch);
    return () => window.cancelIdleCallback(handle);
  }
  const handle = window.setTimeout(prefetch, 1000);
  return () => window.clearTimeout(handle);
}
